import { IonButtons, IonMenuButton, IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonLabel, useIonRouter, IonIcon, IonCard, IonCardContent, IonSkeletonText, IonSpinner, IonChip, IonFab, IonFabButton, IonNote, IonRefresher, IonRefresherContent, RefresherEventDetail, IonImg, useIonViewDidEnter, useIonViewWillEnter, IonCardHeader, IonCardSubtitle, IonCardTitle, IonItemOption, IonItemOptions, IonItemSliding, IonButton, useIonAlert, IonBackButton, IonText, IonBadge } from '@ionic/react';
import { add, addCircleOutline, alarmOutline, alertCircleOutline, arrowBack, caretForwardCircleOutline, checkmarkCircleOutline, chevronBackOutline, copyOutline, helpCircleOutline, informationCircleOutline, locationOutline, navigateOutline, notifications, notificationsOutline, timerOutline, trashOutline, warningOutline } from 'ionicons/icons';
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAppContext } from '../AppProvider';
import Alert from '@mui/material/Alert';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { AlertTitle } from '@mui/material';

const checkDST = () => {
    const now = new Date();
    const januaryOffset = new Date(now.getFullYear(), 0, 1).getTimezoneOffset();
    const julyOffset = new Date(now.getFullYear(), 6, 1).getTimezoneOffset();    
    return now.getTimezoneOffset() !== januaryOffset;
};

const Alarms: React.FC = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [alertVisible, setAlertVisible] = useState<boolean>(false);
    const [alarms, setAlarms] = useState<any[]>([]);
    const [lastLoadTime, setLastLoadTime] = useState<string>('');
    const [todayIsDST, setTodayIsDST] = useState<boolean>(false); 
    const [alarmDST, setAlarmDST] = useState<boolean>(false);

    const { networkStatus, getAppStatus, authKey, authenticateMember, authorizedMember, accountSetupPct, setAccountSetupPct, limits, profiles, settings, getCurrentTimers, textLogoLoaded, fadeInTextLogo, SWTextLogo, SWFullHorizLogo, SWTextDarkLogo, getTimezones, timezoneName, showToast } = useAppContext();

    const router = useIonRouter();
    const [showAlert] = useIonAlert();
    const slidingRef = useRef<HTMLIonItemSlidingElement | null>(null);

    //
    // Authenticate Member
    //
    useIonViewDidEnter(() => { 
        const authenticate = async () => {
            const appstat = await getAppStatus();

            if (!networkStatus && appstat === 'No') {
                router.push('/connection', 'forward');
            } else {
                setLoading(true);
                const authenticated = await authenticateMember();
                                    
                if (!authenticated || authenticated.mt == '') router.push('/login', 'forward');
                else {
                    setTodayIsDST(checkDST());
                    await getTimezones();
                    await getAlarms(authenticated.mt);                
                    setLoading(false);
                }
            }
        };
        authenticate();
    }); 


    //
    // Account Set-Up functions
    //
    useEffect(() => {
        if (profiles.contacts >= 0) {
            let completePct = 0;
            if (authorizedMember.memberFirstName != '' && authorizedMember.memberLastName != '') completePct += 25;
            if (authorizedMember.memberEmail != '') completePct += 25;
            if (profiles.contactsActive >= 1) completePct += 25;
            if (profiles.places >= 1) completePct += 25;

            setAccountSetupPct(completePct);
        }
    }, [authorizedMember, profiles]);


    const getAlarms = async (mt: any) => {
        try {
            const formData = new FormData();
            formData.append('mt', mt);
            formData.append('alarms', 'all');
            const response = await fetch('https://api.besolowise.com/alarms/get/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });

            if(response.ok) {   
                const obj = await response.json();
                //console.log(obj);
                setAlarms(obj);
                const now = new Date();
                const nowDateStr = now.toLocaleTimeString('en-US');
                if(nowDateStr != lastLoadTime) setLastLoadTime(nowDateStr);
            } else {
                showToast({
                    message: 'Response Error.',
                    duration: 3000,
                    color: 'danger',
                    position: 'middle'
                });
            }
        } catch(error) {
            showToast({
                message: 'Connection: ' + error + '.',
                duration: 3000,
                color: 'danger',
                position: 'middle'
            });
        } 
    };


    
    const DSTChip = (s: string) => {
        if (s == '1') 
            return <IonText color={'warning'}>DST</IonText>
        else if (s == '0')  
            return <IonText color={'dark'}>Standard Time</IonText>
    };  

    const statusChip = (s: string) => {
        switch(s) {
            case '0': return <IonChip color={'medium'}><IonIcon icon={timerOutline}></IonIcon><IonLabel>In-Future</IonLabel></IonChip>
            case '1': return <IonChip color={'secondary'}><IonIcon icon={caretForwardCircleOutline}></IonIcon><IonLabel>Active</IonLabel></IonChip>
            case '2': return <IonChip color={'success'}><IonIcon icon={checkmarkCircleOutline}></IonIcon><IonLabel>Checked-In</IonLabel></IonChip>
            case '3': return <IonChip color={'warning'}><IonIcon icon={alertCircleOutline}></IonIcon><IonLabel>Over-Due</IonLabel></IonChip>
            case '4': return <IonChip color={'danger'}><IonIcon icon={alertCircleOutline}></IonIcon><IonLabel>Alert</IonLabel></IonChip>           
            default:  return <IonChip color={'warning'}><IonIcon icon={helpCircleOutline}></IonIcon><IonLabel>Unknown</IonLabel></IonChip>
        }
    };

    const alarmDelayText = (s: string) => {
        switch(s) {
            case '0.00': return 'No'
            case '0.25': return '15-min'
            case '0.50': return '30-min'
            case '1.00': return '1-hour'
            case '2.00': return '2-hour'
            case '3.00': return '3-hour'
            case '6.00': return '6-hour'
            case '12.00': return '12-hour'
            case '24.00': return '24-hour'
            default:  return 'Unknown'
        }
    };


    const viewAlarm = (tt: string) => {
        router.push('/account/alarm/view/'+tt, 'forward');
    }; 


    const handleRefresh = (event: CustomEvent<RefresherEventDetail>) => {
        setLoading(true);
        setTimeout(async () => {
          await getAlarms(authKey.mt);
          event.detail.complete();
          setLoading(false);
        }, 2000);
    };

    const autoRefresh = (prevMinutes: number) => {
        const now = new Date();
        const nowMinutes = now.getMinutes();
        if(prevMinutes === -1 || (nowMinutes == 0 || nowMinutes == 15 || nowMinutes == 30 || nowMinutes == 45) && nowMinutes != prevMinutes) getAlarms(authKey.mt);
        setTimeout(() => autoRefresh(nowMinutes), 30000);
    };

    const toggleAlertContent = () => setAlertVisible(!alertVisible);

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar className='ion-text-center'>
                    <IonButtons slot='start'>
                        <IonBackButton color={'tertiary'}>Back</IonBackButton>
                    </IonButtons>
                    <IonTitle><IonImg className={textLogoLoaded ? 'fade-in' : 'fade-out'} src={settings.theme == '1' ? SWTextDarkLogo : SWFullHorizLogo} onIonImgDidLoad={fadeInTextLogo}></IonImg></IonTitle>
                    <IonButtons slot='end'>
                        <IonMenuButton color={'tertiary'} />
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding account-content-bg">
                
                <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>

                <div className='ion-text-center'>
                    <IonIcon color={'danger'} icon={notificationsOutline} style={{'fontSize': '70px'}}></IonIcon> 
                </div>                
                <div className='ion-padding-bottom'>
                    <h1 className='ion-text-center'>Alarm Log</h1>
                    {/*<IonNote><p>Last Update: {lastLoadTime}</p></IonNote>*/}
                </div>
                <div className='ion-padding'>   
                    <Alert
                        severity="info"
                        icon={<InfoOutlinedIcon fontSize="inherit" />}
                        onClick={toggleAlertContent}
                        sx={{
                            borderLeft: '17px solid #0048AB',
                            borderRadius: 2,
                            mb: 2,
                            cursor: 'pointer'
                        }}
                    >
                        <AlertTitle>What is a SoloWise Alarm?</AlertTitle>
                        {alertVisible &&
                            (<div className='ion-margin-top'>
                                <p>A <strong>SoloWise Alarm</strong> is generated when a check-in is missed or an SOS is sent.</p>
                                <p>Alarms are metered on a monthly basis.</p>
                            </div>)
                        }                        
                    </Alert>
                </div>                

                {alarms.length > 0
                    ? alarms.map((alarm:any, index:number) => (                    
                        <IonCard key={index}>
                            <IonCardHeader>
                                {loading 
                                    ? <>
                                        <IonCardTitle><IonSkeletonText animated={true} style={{ width: '50%' }}></IonSkeletonText></IonCardTitle>
                                        <IonCardSubtitle><IonSkeletonText animated={true} style={{ width: '75%' }}></IonSkeletonText></IonCardSubtitle>
                                    </>
                                    : <>                                      
                                        <IonCardTitle>
                                            <IonIcon icon={notifications} color={'danger'} /> {alarm.alarmTime}                                            
                                        </IonCardTitle>
                                        <IonCardSubtitle className='ion-margin-start ion-padding-start'>
                                            <p>{alarm.timerToken != 'SOS' && 'Missed Check-in: '}{alarm.name}</p>
                                            {alarm.timerToken == 'SOS' 
                                                ? <p>No associated Timer</p>
                                                : <>
                                                    <p><strong>{alarm.startTime} - {alarm.endTime}</strong></p>
                                                    <p>{timezoneName(alarm.timezone)} {DSTChip(alarm.endDST)}</p> 
                                                    <p>{alarmDelayText(alarm.delay)} Alarm Delay</p> 
                                                  </>
                                            }
                                        </IonCardSubtitle>
                                      </>
                                }
                            </IonCardHeader>
                            <IonCardContent className='ion-margin-start ion-padding-start'>     
                                {loading
                                    ? <>
                                        <h2><IonSkeletonText animated={true} style={{ width: '30%' }}></IonSkeletonText></h2>
                                       </>
                                    : <>
                                        <div>
                                            
                                        </div>
                                       </>
                                }
                            </IonCardContent>
                        </IonCard>
                      ))
                    : loading
                          ? <p className='ion-text-center'>Loading<br /><IonSpinner className='ion-margin-top' name="crescent"></IonSpinner></p>
                          : <>
                                <p className='ion-text-center'>You have no recorded SoloWise Alarms.</p>
                             </>
                        
                }
                
            </IonContent>
        </IonPage>
    );
};

export default Alarms;